import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const easeOut = [0.23, 1, 0.32, 1] as const;
const heroReassurance = ['Immediate Digital Access', 'One-Time Payment', '7-Day Guarantee'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-white" data-id="element-151" data-mp="12862k3i3uktp">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-152" data-mp="xbfmhg6avp8a">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} className="w-full" data-id="element-153" data-mp="sart4nulmwaw">
          <div className="inline-block px-3 py-1 rounded-full border border-[#A7B7C1] bg-[#0F4C5C] text-white font-bold text-[10px] sm:text-sm tracking-widest mb-4 sm:mb-6" data-id="element-154" data-mp="3d21ty23jwspu">
            DENTAL INSTRUCTOR <span className="text-[#8FDCD7]" data-id="element-155" data-mp="3j7zfnjujfuh7">ATLAS</span>
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight mb-4 sm:mb-6 text-[#0F4C5C] uppercase" data-id="element-156" data-mp="3j6od1nctwsro">
            Solve <span className="text-[#0B7A7A]" data-id="element-157" data-mp="399jnddjryf64">Months of Dental Class Planning</span>{' '}
            <span className="bg-[#0F4C5C] text-white px-2 box-decoration-clone" data-id="element-158" data-mp="3e8ei9dv0nu6l">in Just 5 Minutes!</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: easeOut
      }} className="relative w-full max-w-[360px] sm:max-w-xl md:max-w-2xl mb-4 sm:mb-6" data-id="element-159" data-mp="30fy9dwffp1xr">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="relative z-10 w-full h-auto drop-shadow-xl" data-id="element-160" data-mp="2vj7tb93mq6cc" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: easeOut
      }} className="w-full" data-id="element-161" data-mp="2ljpef72ktar5">
          <p className="text-sm sm:text-lg md:text-xl text-slate-700 leading-snug max-w-3xl mx-auto mb-1 sm:mb-2" data-id="element-162" data-mp="n9qhz7v3iq6w">
            The Complete{' '}
            <span className="font-semibold text-[#0A6464]" data-id="element-163" data-mp="dd5ews2mzp5p">
              6-IN-1 Visual Dentistry Teaching &amp; Clinical Training System for Dental Instructors, Clinical Faculty &amp; Dental Educators.
            </span>
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-164" data-mp="162ugb6j9dr7u">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10" data-id="element-165" data-mp="112pv537eo8ba">
              {PRIMARY_CTA}
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-slate-700/80 mb-3" data-id="element-166" data-mp="3lui9cqv5izld">
            {heroReassurance.map(item => <div key={item} className="flex items-center gap-1.5" data-id="element-167" data-mp="1xa41h7xz88gg">
                <CheckCircle size={14} className="text-[#0B7A7A]" data-id="element-168" data-mp="21awco6qesnfd" />
                <span className="font-medium" data-id="element-169" data-mp="21b63txn6x0mn">{item}</span>
              </div>)}
          </div>

          <p className="text-sm sm:text-lg md:text-xl text-slate-700 leading-snug max-w-3xl mx-auto mb-3 sm:mb-4" data-id="element-170" data-mp="267wicgjcjo5y">
            <span className="font-semibold text-[#0F4C5C]" data-id="element-171" data-mp="2b2kcaux4darx">6 Professional Visual Training Volumes</span> + 5
            Exclusive Bonuses — everything organized to help you plan, explain, demonstrate and assess every
            dental lecture, simulation lab and clinical session, from tooth anatomy and radiology to restorative dentistry, endodontics, periodontics, oral surgery and local anesthesia, from beginner to advanced, with more clarity, structure and confidence.
          </p>

          <p className="text-xs sm:text-sm font-bold tracking-widest text-[#0A6464] mb-5 sm:mb-7" data-id="element-172" data-mp="uokf3rpnrz8d">
            FROM DENTAL ANATOMY &amp; DIAGNOSIS TO CLINICAL PROCEDURES, ORAL SURGERY &amp; TEACHING METHODS
          </p>

          <p className="text-xs text-slate-500" data-id="element-173" data-mp="3vhxijq1klk1p">
            6 VISUAL VOLUMES · 300 TRAINING PAGES · 5 EXCLUSIVE BONUSES
          </p>
        </motion.div>
      </div>
    </section>;
}